import axios from './axiosConfig';

export const getAlertSummary = async () => {
    try {
        const response = await axios.get('/api/alert-summary');
        console.log('✅ Alert Summary Data:', response.data);
        return response.data;
    } catch (error) {
        console.error('❌ Failed to fetch alert summary:', error);
        return null;
    }
};

